import React from 'react';
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";
import {LatLng} from "leaflet";
import {buildPointIconSingleVoyage} from "@containers/singleVoyage/containers/points/icon/buildPointIcon";
import LeafletMarker from "@ui/leafletCustom/leafletMarker/LeafletMarker";

interface IProps {
    point: IWayPointCreationWithCorrectionsSingleVoyage,

}

const DefaultPointChangeCorrectionsSingleVoyages = ({point}: IProps) => {
    const {lat, lng} = getLatLngFromPointGeomCoordinates(point.geom)
    const latLng = new LatLng(lat, lng)
    const icon = buildPointIconSingleVoyage({
        name: point.name,
        number: point.plannedOrdinal + 1,
    })
    return (
        <LeafletMarker
            position={latLng}
            icon={icon}
            key={point.id}
        />
    )
};

export default DefaultPointChangeCorrectionsSingleVoyages;